import { render, staticRenderFns } from "./MiddlePanelReservationPreorder.vue?vue&type=template&id=55eaf19c&scoped=true&lang=pug&"
import script from "./MiddlePanelReservationPreorder.vue?vue&type=script&lang=js&"
export * from "./MiddlePanelReservationPreorder.vue?vue&type=script&lang=js&"
import style0 from "./MiddlePanelReservationPreorder.vue?vue&type=style&index=0&id=55eaf19c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55eaf19c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VDivider,VIcon,VProgressLinear,VSkeletonLoader,VSpacer})
